
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M255.997 1C152.692 1 68.647 85.23 68.647 188.761c0 27.006 5.517 52.788 16.385 76.643 46.842 102.72 136.652 211.172 163.068 241.963a10.406 10.406 0 0015.804 0c26.41-30.784 116.215-139.229 163.068-241.963 10.871-23.854 16.381-49.637 16.381-76.643C443.342 85.23 359.301 1 255.997 1zm0 285.281c-53.66 0-97.32-43.752-97.32-97.525 0-53.782 43.66-97.533 97.32-97.533s97.318 43.751 97.318 97.533c-.001 53.773-43.659 97.525-97.318 97.525z"}})])
          )
        }
      }
    